import Vue from 'vue';
import Vuex from 'vuex';
import common from './common';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    userInfo: null,
  },
  modules: {
    common,
  },
  mutations: {
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo;
    },
    // 清除用户信息（登出用）
    clearUserInfo(state) {
      state.userInfo = null;
    }
  },
  getters: {
    // 获取用户信息
    getUserInfo: (state) => state.userInfo,
    // 判断是否登录
    isLoggedIn: (state) => state.userInfo !== null && state.userInfo.token !== undefined,
    // 获取用户ID
    getUserId: (state) => state.userInfo?.userId || null,
  }
});

export default store;